import axios from "axios";

const API = axios.create({
    //baseURL: "https://api.shrianshnexus.in/api", // your backend
    baseURL: "https://api.shrianshnexus.in/api", // your backend
    headers: {
        "Content-Type": "application/json"
    }
});

export default API;
